import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex max-w-200 flex-col-reverse justify-end gap-2 lg:flex-row lg:gap-10',
    imageWrapper:
      'bg-blue-light flex h-full w-full shrink-0 grow-0 items-center',
    image: 'aspect-square w-full object-cover',
    arrow: 'border-0',
    viewport: 'relative overflow-hidden',
    container: 'flex h-full items-center',
    tags: 'absolute top-2.5 left-2.5 z-10 flex gap-[2px] lg:top-6 lg:right-6 lg:left-auto',
    thumbs: 'flex items-center gap-2 lg:mt-6 lg:flex-col',
    thumbsViewport:
      'w-[calc(100vw-32px)] overflow-hidden lg:max-h-133 lg:w-auto',
    thumbsContainer: 'flex items-center gap-2 lg:h-full lg:flex-col',
    thumbArrow: 'z-10 hidden h-6 border-0 p-0 text-black lg:block'
  },
  variants: {
    hide: {
      true: {
        arrow: 'opacity-0',
        thumbArrow: 'opacity-0'
      }
    }
  }
});
